import { defineStyleConfig } from "@chakra-ui/react";

const Spinner = defineStyleConfig({
  // The styles all button have in common
  baseStyle: {
    color: "var(--chakra-colors-primary-300)", // Use Chakra's color palette or a custom color
  },
});

export default Spinner;
